<template>
  <div>
    <tabs
      :links="externalConnexionTabLinks()"
      :level="1"
      :is-fullwidth="true"
      class="has-background-white is-margin-bottom"></tabs>
    <router-view
      @backToInitialAdv="backToInitialAdv"
      @grimmoModificationFinish="grimmoModificationFinish"></router-view>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import AdvMixin from '@/mixins/AdvMixin'
export default {
  name: 'ExternalConection',
  mixins: [AdvMixin],
  data () {
    return {
      sageConnection: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'canUseElectronicSign', 'canUseBuyerSpace', 'canUseCalendar', 'plan']),
    ...mapState(['currentAdv', 'currentSale', 'pendingSubmit', 'currentAccount']),
    advPk () {
      return this.$route.params.id
    }
  },
  async created () {
    // this.isSageConnector()
  },
  methods: {
    getRoute () {
      return this.$route.name
    },
    externalConnexionTabLinks () {
      this.isSageConnector()
      let tabs = []
      tabs.push({ link: 'ExternalConnectionHistory', label: 'Historique' })
      if (!this.sageConnection) {
        if (this.program.is_amenagement) {
          tabs.push({ link: 'ExternalConnectionSpo', name: 'spo', label: 'SPO informations' })
        } else {
          tabs.push({ link: 'ExternalConnectionGrimmo', name: 'grimmo', label: 'Grimmo informations' })
        }
      }
      return tabs
    },
    backToInitialAdv () {
      this.$router.push({ name: 'AdvInfos', params: { id: this.advPk }, query: { returnId: this.advPk } })
      this.$emit('backToInitialAdv')
    },
    grimmoModificationFinish () {
      this.$router.push({ name: 'AdvInfos', params: { id: this.advPk }, query: { returnId: this.advPk } })
    },
    isSageConnector () {
      if (this.currentAccount.sage_connector && this.currentAccount.sage_connector.length > 0) {
        this.sageConnection = true
      }
    }
  }
}
</script>
